module.exports = __webpack_public_path__ + "0885ccc37a83f01dc8ae56b3a13deb5b.woff2";